"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-restricted-syntax */
const three_1 = require("three");
// eslint-disable-next-line import/no-cycle
const types_1 = require("~/store/types");
// eslint-disable-next-line import/no-cycle
const Viewer_1 = __importDefault(require("../Viewer"));
const PlasticPanelCutouts_3d_1 = require("../classes/PlasticPanelCutouts.3d");
// eslint-disable-next-line import/no-cycle
const Command_1 = require("./Command");
// eslint-disable-next-line import/no-cycle
const events_1 = require("../../../utils/events");
// eslint-disable-next-line import/no-cycle
const AddObjectCommand_1 = __importDefault(require("./AddObjectCommand"));
const utils_3d_1 = require("../utils/utils.3d");
class RemoveObjectCommand extends Command_1.ViewerCommand {
    constructor(objects, viewer, historyService) {
        super();
        this.type = 'RemoveObjectCommand';
        this.name = `Remove Objects: `;
        this.objects = objects;
        this.viewer = viewer;
        this.designProMain = viewer.getDesignProMain();
        this.historyService = historyService;
        for (const object of this.objects) {
            this.name += `${object.name}; `;
        }
    }
    // eslint-disable-next-line class-methods-use-this
    update() {
        /* do nothing */
    }
    execute(appliedFromHistory) {
        if (!this.objects.length) {
            return;
        }
        this.historyService.emit(`${this.objects[0].type}Removed`, this.objects); // TODO: should be rewritten in future
        const events = [];
        this.objects.forEach((object) => {
            var _a;
            this.viewer.collisionProcessor.notifyObjectRemoved(object);
            this.designProMain.connectionManager.updateConnections(object);
            object.removeFromParent();
            events.push({
                actionType: types_1.ACTION_TYPE.REMOVE,
                itemNumber: object.partDetails.itemNumber,
                itemType: object.type,
                uuid: object.uuid,
                appliedFromHistory,
                isAiAction: !!((_a = object.userData) === null || _a === void 0 ? void 0 : _a.aiAssemblyId),
            });
            object.uuidsObjectsInsertedIntoPlate.forEach((el) => {
                const insertedObject = (0, utils_3d_1.getObjectByUUID)(Viewer_1.default.instance.getScene(), el);
                if (insertedObject) {
                    this.viewer.collisionProcessor.updateCollisions(insertedObject);
                }
            });
        });
        this.designProMain.capHelper.updateCones();
        // TODO: remove later
        if ((0, utils_3d_1.isFastener)(this.objects[0])) {
            return;
        }
        document.body.dispatchEvent((0, events_1.removeItemsFromBOMEvent)(events));
        (0, PlasticPanelCutouts_3d_1.refreshPlasticPanels)(this.viewer, appliedFromHistory);
        this.designProMain.resetLastScaledObject();
    }
    undo() {
        new AddObjectCommand_1.default(this.objects, this.viewer, this.historyService).execute(false);
    }
    toJSON() {
        const JSONObjects = [];
        // eslint-disable-next-line no-restricted-syntax
        for (const object of this.objects) {
            JSONObjects.push(object.toJSON());
        }
        return {
            type: this.type,
            id: this.id,
            name: this.name,
            object: JSONObjects,
        };
    }
    fromJSON(json) {
        this.objects = [];
        // eslint-disable-next-line no-restricted-syntax
        for (const object of json.object) {
            if (this.viewer.getObjectById(object.uuid) === undefined) {
                const loader = new three_1.ObjectLoader();
                this.objects.push(loader.parse(object));
            }
        }
    }
}
exports.default = RemoveObjectCommand;
